module.exports = __webpack_public_path__ + "img/DSC_0180 teatro beto_thumb.f3eabcf4.jpg";